// extracted by mini-css-extract-plugin
export var announcer = "TestimonialCarousel-module--announcer--b6783";
export var btnNext = "TestimonialCarousel-module--btnNext--7906b";
export var btnPrev = "TestimonialCarousel-module--btnPrev--e7887";
export var container = "TestimonialCarousel-module--container--8a1f3";
export var controls = "TestimonialCarousel-module--controls--1a011";
export var count = "TestimonialCarousel-module--count--6fda0";
export var slider = "TestimonialCarousel-module--slider--d32fc";